import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation removeProcessingUserAccess($id: ID!, $username: String!) {
      deleteProcessingUserAccess(id: $id, username: $username) {
        success
      }
    }
  `,
  mutationName: "removeProcessingUserAccess",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/access/removeUserAccess.js